<div class="container-fluid">
  <app-gene-table-selector [showGenomic] = true [showAssembly] = false [showRepseq]=false></app-gene-table-selector>
  <app-gen-explore-data-panel></app-gen-explore-data-panel>
</div>
